import { createStyles, makeStyles } from "@material-ui/core";
import { RelodeTheme } from "@relode/core";
import classnames from "classnames";
import * as React from "react";

const getGridTemplateRows = (children: React.ReactNode): string => {
    let gridTemplateRows = "";
    React.Children.toArray(children).forEach(
        () => (gridTemplateRows = gridTemplateRows + " auto")
    );
    return gridTemplateRows;
};

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                padding: theme.spacing(2, 0, 3, 0),
                display: "grid",
                gridTemplateColumns: "auto",
                // need the template rows to match number of children else you have extra space at the bottom of page
                gridTemplateRows: (props: DashboardContentProps) =>
                    getGridTemplateRows(props.children),
                gridRowGap: theme.spacing(4),
                gridColumnGap: 0,
            },
        }),
    { name: "DashboardContent" }
);

interface DashboardContentProps {
    children: React.ReactNode;
    className?: string;
}

export const DashboardContent = (props: DashboardContentProps) => {
    const classes = useStyles(props);
    return (
        <div className={classnames(classes.root, props.className)}>
            {props.children}
        </div>
    );
};
